import styled from '@emotion/styled';
import { Tooltip } from 'react-magma-dom';

export const StyledTooltipArrow = styled.div`
  position: absolute !important;
  width: 8px;
  height: 16px;
  border-style: solid;
  border-width: 8px 8px 8px 0;
  left: -8px;
  top: 12px;
  border-color: transparent white transparent transparent;
`;

export const StyledTooltipText = styled.div`
  position: absolute !important;
  left: 30.7px;
  background: white;
  top: -10px;
  min-width: 100px;
  min-height: 40px;
  display: none;
  padding: 7px 7px 7px 8px;
  border-radius: 2px;
  box-shadow: 0px 5px 8px 0px rgba(34, 60, 80, 0.2);
  z-index: 1;
`;

export const StyledTooltip = styled.div`
  position: relative;
  margin-left: 7.7px;
  display: flex;

  font-family: Lexend;
  font-size: 10px;
  font-weight: 500;
  text-align: left;

  :hover {
    div {
      display: block;
    }

    svg {
      path {
        fill: white;
      }
    }
  }
`;

export const StyledColoredTooltip = styled(Tooltip)<{ background: string }>`
  div {
    font-family: Lexend;
  }

  span {
    :before {
      background: ${({ background }) => background} !important;
    }
  }
`;

export const StyledArrowBoxShadowTooltip = styled(Tooltip)`
  span {
    :before {
      box-shadow: 1px 1px rgba(0, 0, 0, 0.35);
    }
  }
`;
